module.exports = __webpack_public_path__ + "static/media/home-filled.293fafce.svg";